export const apiQueryKey = (...key: unknown[]) => ["api", ...key] as const;
